module.exports = __webpack_public_path__ + "img/partner3.abb43a3b.jpg";